import { pickBy } from "lodash-es";
import { shallow } from "zustand/shallow";

import { createWithEqualityFn } from "zustand/traditional";

type SelectedProjectsStore = {
  selectedProjects: Record<string, boolean>;

  setSelectedProjects: (projects: Record<string, boolean>) => void;
  getSelectedProjects: () => string[];
  clear: () => void;
};

export const useSelectedProjectsStore =
  createWithEqualityFn<SelectedProjectsStore>(
    (set, get) => ({
      selectedProjects: {},

      setSelectedProjects: (projectUpdate) => {
        set((state) => ({
          selectedProjects: { ...state.selectedProjects, ...projectUpdate },
        }));
      },
      getSelectedProjects: () =>
        Object.keys(pickBy(get().selectedProjects, (p) => p)),

      clear: () => {
        set(() => ({ selectedProjects: {} }));
      },
    }),
    shallow,
  );
